@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.appSettings

fun getOfficialAppUrl(platform: Platform) = when (platform) {
    Platform.iOS -> "https://apps.apple.com/app/carapp/idxxxxxxxxxx"
    Platform.Android -> "https://play.google.com/store/apps/details?id=com.narbase.letsgo.carapp.passenger"
    Platform.Web -> null
}